// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    // Check localStorage on initial load
    const tokenString = localStorage.getItem('adminToken');
    if (tokenString) {
      try {
        const token = JSON.parse(tokenString);
        if (token.expires > Date.now()) {
          setAuth(token);
        } else {
          localStorage.removeItem('adminToken');
        }
      } catch (e) {
        localStorage.removeItem('adminToken');
      }
    }
  }, []);

  const login = (token) => {
    localStorage.setItem('adminToken', JSON.stringify(token));
    setAuth(token);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setAuth(null);
    window.location.href = '/'; // Full page reload
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);